import React from 'react'
import {createIcon} from '@chakra-ui/react'

export const CommentIcon = createIcon({
  displayName: 'CommentIcon',
  viewBox: '0 0 16 16',
  path: (
    <path
      d="M14.66 2.66683C14.66 1.9335 14.0667 1.3335 13.3334 1.3335H2.66671C1.93337 1.3335 1.33337 1.9335 1.33337 2.66683V10.6668C1.33337 11.4002 1.93337 12.0002 2.66671 12.0002H12L14.6667 14.6668L14.66 2.66683ZM13.3334 2.66683V11.4468L12.5534 10.6668H2.66671V2.66683H13.3334ZM4.00004 8.00016H12V9.3335H4.00004V8.00016ZM4.00004 6.00016H12V7.3335H4.00004V6.00016ZM4.00004 4.00016H12V5.3335H4.00004V4.00016Z"
      fill="currentColor"
    />
  ),
})
